import {
  TROUBLE_TICKET_ADDED,
  TROUBLE_TICKET_DELETED,
  TROUBLE_TICKET_EDITED,
  TROUBLE_TICKET_SET,
} from 'src/app/redux/redux-types';
import { reduxTroubleTicketTypes } from 'src/types';

export const troubleTicketDefaultState: reduxTroubleTicketTypes.StateType = {
  troubleTicketList: [],
  isTTFetchRequestCompleted: false,
};

export const troubleTicketReducer = (
  state = troubleTicketDefaultState,
  action: reduxTroubleTicketTypes.ActionType,
): reduxTroubleTicketTypes.StateType => {
  switch (action.type) {
    case TROUBLE_TICKET_SET:
      return {
        ...state,
        troubleTicketList: action.payload.list,
        isTTFetchRequestCompleted: action.payload.isTTFetchRequestCompleted,
      };
    case TROUBLE_TICKET_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.troubleTicketList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        troubleTicketList: [action.payload, ...state.troubleTicketList],
      };
    case TROUBLE_TICKET_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.troubleTicketList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        troubleTicketList: [
          ...state.troubleTicketList.slice(0, updateIndex),
          action.payload,
          ...state.troubleTicketList.slice(updateIndex + 1),
        ],
      };
    case TROUBLE_TICKET_DELETED:
      return {
        ...state,
        troubleTicketList: state.troubleTicketList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
